import { useWorkspaceDomainKnowledge, useWorkspaceRiskCatalog, useWorkspaceRisksList } from "@/api/workspace-risks";
import { ExportCsvButton } from "@/components/ExportCsvButton";
import { buildRiskGroupsFromCatalog } from "@/components/safety-config/risk-groups";
import { downloadCSV } from "@/utils/download-csv";
import {
  buildWorkspaceRisksCsvRows,
  WORKSPACE_RISKS_CSV_HEADERS,
  WORKSPACE_RISKS_CSV_PRETTY_HEADERS,
  workspaceRisksCsvFilename,
} from "./workspace-risks-csv";

type WorkspaceRisksExportButtonProps = {
  workspaceId: string;
  workspaceName: string;
};

export const WorkspaceRisksExportButton = ({ workspaceId, workspaceName }: WorkspaceRisksExportButtonProps) => {
  const { data: catalog } = useWorkspaceRiskCatalog(workspaceId);
  const { data: workspaceRisksList } = useWorkspaceRisksList(workspaceId);
  const { data: domainKnowledge } = useWorkspaceDomainKnowledge(workspaceId);

  const handleExport = () => {
    if (!catalog || !workspaceRisksList) return;
    const groups = buildRiskGroupsFromCatalog(catalog);
    const rows = buildWorkspaceRisksCsvRows(groups, catalog, workspaceRisksList, domainKnowledge ?? {});

    downloadCSV(
      rows,
      "workspace-risks",
      [...WORKSPACE_RISKS_CSV_HEADERS],
      WORKSPACE_RISKS_CSV_PRETTY_HEADERS,
      workspaceRisksCsvFilename(workspaceName, new Date()),
    );
  };

  return (
    <ExportCsvButton
      onClick={handleExport}
      isDownloading={false}
      disabled={!catalog || !workspaceRisksList}
      label="Export risks as CSV"
    />
  );
};
